import { render, staticRenderFns } from "./IconAngleLeft.vue?vue&type=template&id=57a9fc28&"
import script from "./IconAngleLeft.vue?vue&type=script&lang=js&"
export * from "./IconAngleLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports